import { Fuel, Search, Navigation, Filter } from 'lucide-react';

export const WelcomeScreen = () => {
  return (
    <div 
      data-testid="welcome-screen"
      className="flex flex-col items-center justify-center py-16 px-6 text-center"
    >
      <div className="w-20 h-20 bg-black dark:bg-white flex items-center justify-center mb-6 shadow-hard">
        <Fuel className="w-10 h-10 text-white dark:text-black" />
      </div>
      
      <h2 className="font-heading text-2xl font-bold uppercase text-black dark:text-white mb-4 tracking-tight">
        Trouvez le meilleur prix
      </h2>
      
      <p className="text-gray-600 dark:text-gray-400 mb-8 max-w-xs">
        Comparez les prix des carburants dans toute la France
      </p>

      <div className="space-y-4 text-left w-full max-w-xs">
        <div className="flex items-start gap-3 p-3 bg-white dark:bg-gray-800 border-2 border-black dark:border-gray-600">
          <Search className="w-5 h-5 text-[#FF4500] flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-bold text-sm uppercase tracking-wide text-black dark:text-white">Recherche</p>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">Entrez une ville ou code postal</p>
          </div>
        </div>

        <div className="flex items-start gap-3 p-3 bg-white dark:bg-gray-800 border-2 border-black dark:border-gray-600">
          <Navigation className="w-5 h-5 text-[#FF4500] flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-bold text-sm uppercase tracking-wide text-black dark:text-white">Géolocalisation</p>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">Stations autour de vous</p>
          </div>
        </div>

        <div className="flex items-start gap-3 p-3 bg-white dark:bg-gray-800 border-2 border-black dark:border-gray-600">
          <Filter className="w-5 h-5 text-[#FF4500] flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-bold text-sm uppercase tracking-wide text-black dark:text-white">Filtres</p>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">Gazole, SP95, E10, E85...</p>
          </div>
        </div>
      </div>
    </div>
  );
};
